import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Button,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormControlLabel,
  Checkbox,
  Divider,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { rem } from "assets/js/common";
import { Link } from "react-router-dom";
import { Cookies } from "react-cookie";
import { useHistory } from "react-router-dom";
import Loading from "components/ui/loading";
import jwt_decode from "jwt-decode";
import AlertConfirm from "components/ui/alert-confirm";
import AlertComplete from "components/ui/alert-complete";

const useStyles = makeStyles((theme) => ({
  favoriteProduct: {
    "& .favorite-list": {
      "& > li": {
        display: "flex",
        alignItems: "center",
        "& .MuiFormControlLabel-root": {
          paddingRight: rem(15),
          "& .MuiCheckbox-root": {
            padding: 0,
          },
        },
        "& .favorite-img": {
          position: "relative",
          width: rem(80),
          height: rem(80),
          background: theme.palette.background.default,
          borderRadius: rem(10),
          "& .img-wrap": {
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            margin: "auto",
            maxWidth: "60%",
            maxHeight: "60%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& img": {
              maxWidth: "100%",
              maxHeight: "100%",
            },
          },
        },
        "& + li": {
          marginTop: rem(20),
        },
        "& .favoriteImage": {
          borderRadius: rem(10),
        },

        "& .info": {
          flex: 2,
          paddingLeft: rem(14),
          "& .title": {
            fontSize: rem(14),
            textAlign: "left",
          },
          "& .cost": {
            display: "flex",
            alignItems: "center",
            marginTop: rem(4),
            fontSize: rem(14),
            fontWeight: 700,

            "& strong": {
              fontSize: rem(16),
              fontWeight: 800,
              paddingRight: rem(2),
            },
          },
        },
      },
    },
  },
}));

const cookies = new Cookies();

export default function FavoriteProduct() {
  const classes = useStyles();
  const no = cookies.get("no");
  const history = useHistory();

  const [favoriteProductList, setFavoriteProductList] = useState([]);
  const [noticeExpanded, setNoticeExpanded] = useState();
  const [delArr, setDelArr] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [open, setOpen] = useState(false);
  const [alertMode, setAlertMode] = useState("");

  const [memo, setMemo] = useState({
    content: "",
    count: 0,
    limit: 10,
    checkArr: [],
  });

  const handleAlertClose = () => {
    setOpen(false);
  };

  const onSelectDelete = (seq) => {
    axios.post("/api/eh/product/favorite/remove-list", delArr).then((res) => {
      fetchData();
      setDelArr([]);
    });
  };

  const onAllDelete = () => {
    axios
      .post("/api/eh/product/favorite/remove-all", null, {
        params: {
          no: no,
        },
      })
      .then((res) => {
        fetchData();
      });
  };

  const fetchData = async () => {
    await axios
      .get("/api/eh/product/favorite", {
        params: {
          no: no,
        },
      })
      .then((res) => {
        setFavoriteProductList(res.data.data.productList);
        setFetching(false);
      })
      .catch((error) => {
        setFetching(false);
      });
  };

  const handleNotice = (panel) => (event, newExpanded) => {
    setNoticeExpanded(newExpanded ? panel : false);
  };

  const handleChangeCheckbox = (event) => {
    const target = event.target;

    let arr = [...delArr];

    if (target.checked) {
      arr.push(Number(target.value));
    } else {
      _.remove(arr, (item) => item == target.value);
    }

    setDelArr(arr);

    console.log("arr", arr);
  };

  useEffect(() => {
    fetchData();
  }, []);
  window.appBackKeyHandle = () => {
    if (open) {
      setOpen(false);
    } else {
      history.goBack();
    }
  };

  const handleFav = (item) => {
    axios
      .post("/api/eh/product/favorite/fav", {
        seq: item.seq,
      })
      .then((res) => {
        fetchData();
      });
  };

  return (
    <>
      <Loading open={fetching} />
      <div className={classes.favoriteProduct}>
        {favoriteProductList.length == 0 ? (
          <>
            <Box className="box-type-3" style={{ paddingTop: rem(40) }}>
              <h3 className="weight800">찜한 상품</h3>
            </Box>
            <div className="nodata" style={{ padding: "40px 0 70px" }}>
              <Box className="illust" mb={6}>
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/nodata-like.svg`}
                />
              </Box>
              <p>
                <b>찜한 상품이 없습니다</b>
              </p>
              <p className="info-txt">
                장볼 상품을 찜해두고
                <br />
                쇼핑 메모에서 편하게 관리하세요!
              </p>
              <Box mt={5}>
                <Link
                  to={"/product-of-week"}
                  className="link-outlined link-primary link-size-small btn-rounded end-icon"
                >
                  전단 바로가기
                  <i className="ico-go" />
                </Link>
              </Box>
            </div>
          </>
        ) : (
          <>
            <Box className="box-type-3">
              <h3 className="weight800">찜한 상품</h3>
            </Box>
            <Box className="box-type-3" style={{ paddingTop: 0 }}>
              <ul className="favorite-list">
                {favoriteProductList.map((item, i) => (
                  <li
                    key={i}
                    onClick={(e) => {
                      history.push(`/product-of-week/detail/${item.seq}`);
                    }}
                  >
                    <FormControlLabel
                      value={item.seq}
                      control={
                        <Checkbox
                          color="primary"
                          icon={<span className="checkbox-icon" />}
                          checkedIcon={
                            <span className="checkbox-icon-checked" />
                          }
                          // onChange={(e) => {
                          //   e.stopPropagation();
                          //   handleChangeCheckbox(e, item.seq);
                          // }}

                          onClick={(e) => {
                            e.stopPropagation();
                            handleChangeCheckbox(e, item.seq);
                          }}
                        />
                      }
                      checked={delArr.includes(Number(item.seq))}
                      label=""
                    />
                    <div className="favorite-img">
                      <div className="img-wrap">
                        <img src={item.prodImgUrl} className="favoriteImage" />
                      </div>
                    </div>
                    <div className="info">
                      <p className="title">{item.ttl}</p>
                      <p className="cost">
                        <strong>{item.prc.toLocaleString()}</strong>원
                      </p>
                    </div>
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleFav(item);
                      }}
                    >
                      <img
                        src={`${
                          process.env.PUBLIC_URL
                        }/images/icon/favorite.svg`}
                        style={{ width: "32px", height: "32px" }}
                      />
                    </Button>
                  </li>
                ))}
              </ul>
              <div className="btns-text">
                <Button
                  color="info"
                  onClick={() => {
                    if (delArr.length == 0) {
                      setAlertMode("nodata");
                      setOpen(true);
                    } else {
                      setAlertMode("deleteConfirm");
                      setOpen(true);
                    }
                  }}
                >
                  선택삭제
                </Button>
                <Button
                  color="info"
                  onClick={() => {
                    if (favoriteProductList) {
                      setAlertMode("deleteAllConfirm");
                      setOpen(true);
                    }
                  }}
                >
                  찜 전체삭제
                </Button>
              </div>
            </Box>
            <Divider />
            <Box className="notice is-bottom">
              <Accordion
                expanded={noticeExpanded === "notice"}
                onChange={handleNotice("notice")}
                className="item"
              >
                <AccordionSummary
                  aria-controls="notice-content"
                  id="notice-header"
                >
                  <p className="title">
                    <i className="ico-noti" />
                    유의사항
                  </p>
                </AccordionSummary>
                <AccordionDetails>
                  <ul className="list list-dot color-info font-14">
                    <li>
                      찜한 상품은 전단 행사 기간이 종료되면 자동 삭제됩니다.
                    </li>
                    <li>상품 가격, 입점여부는 점포별로 상이할 수 있습니다.</li>
                  </ul>
                </AccordionDetails>
              </Accordion>
            </Box>
          </>
        )}
      </div>
      {alertMode == "deleteConfirm" ? (
        <>
          <AlertConfirm
            open={open}
            handleAlertClose={handleAlertClose}
            text={"선택된 찜을 삭제하시겠습니까?"}
            action={() => {
              onSelectDelete();
              handleAlertClose();
            }}
          />
        </>
      ) : alertMode == "deleteAllConfirm" ? (
        <>
          <AlertConfirm
            open={open}
            handleAlertClose={handleAlertClose}
            text={"모든 찜 리스트를 삭제하시겠습니까?"}
            action={() => {
              onAllDelete();
              handleAlertClose();
            }}
          />
        </>
      ) : (
        <>
          <AlertComplete
            open={open}
            handleAlertClose={handleAlertClose}
            text={"선택된 찜이 없습니다."}
            action={() => {
              handleAlertClose();
            }}
          />
        </>
      )}
    </>
  );
}
